import * as React from 'react';
import { MenuItem } from '@chakra-ui/react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignLeft } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';

export const LeftAlignButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <MenuItem
         onClick={() => editor.chain().focus().setTextAlign('left').run()}
         isDisabled={editor.isActive({ textAlign: 'left' })}
         icon={<FontAwesomeIcon icon={faAlignLeft} size="lg" />}
         title={_js('Left Align')}
         iconSpacing={0}
      ></MenuItem>
   );
};
